import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { getFilterLable } from '../app.utils';

@Component({
  selector: 'app-support-ticket',
  templateUrl: './support-ticket.component.html',
  styleUrls: ['./support-ticket.component.scss'],
})
export class SupportTicketComponent extends BaseCtl {
  public usecaseAttributes: any = [];
  public attributeList: any = [];

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator.config.get('endpoint.supportticket'), locator, route);
    let _self = this;
 
    _self.form.data.id = Number(this.route.snapshot.paramMap.get('id'));
    _self.getUsecaseDetails();
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.title = data.title;
    form.ticketnumber = data.ticketnumber;
    form.headtitle = data.headtitle;
    form.description = data.description;
    form.customerId = data.customerId;
    form.customer = data.customer;
    form.priority = data.priority;
    form.status = data.status;
    form.category = data.category;
    form.assignedGroup = data.assignedGroup;
    form.contactPerson = data.contactPerson;
    form.contactNumber = data.contactNumber;
    form.resolvedStatus = data.resolvedStatus;
    form.resolvedComment = data.resolvedComment;
    form.relatedTo = data.relatedTo;
    form.issuedate = data.issuedate;
    form.severity = data.severity;
    form.assignTo = data.assignTo;
    form.imageId = data.imageId;
  }

  public async getUsecaseDetails() {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory') +
      '/getDetails/support-ticket';
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.getUsecaseSchema(res.result.data['id']);
    });
  }
  public async getUsecaseSchema(usecaseId: any) {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      usecaseId;
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.attributeList = res.result.data;
    });
  }

  /**
   * Filter attribute list
   *
   * @returnssearc
   */
  public filterAttributes(): any {
    return this.attributeList.filter((e: any) => e['system'] != 1);
  }

  getFilterLable = getFilterLable;

  public getInputType(t: string) {
    if (t === 'date') {
      return t;
    } else if (t === 'number' || t === 'decimal') {
      return 'number';
    }
    if (t === 'text') {
      return 'text';
    }
    if (t === 'date') {
      return t;
    }
    if (t === 'time') {
      return t;
    }
    if (t === 'file') {
      return t;
    }
    if (t === 'textarea') {
      return t;
    }
    if (t === 'password') {
      return t;
    } else {
      return 'text';
    }
  }

  getColums(feild: any, columns: number) {
    let size = Number(columns);
    if (feild['code'] == 'category') {
      size = 3;
    } else if (feild['code'] == 'severity') {
      size = 3;
    } else if (feild['code'] == 'priority') {
      size = 3;
    } else if (feild['code'] == 'assignTo') {
      size = 3;
    } else if (feild['code'] == 'title') {
      size = 12;
    } else if (feild['code'] == 'description') {
      size = 12;
    } else if (feild['code'] == 'customerName') {
      size = 12;
    }
    return size;
  }
}
